import React from "react";
import "./css/HomePage.css";
import { Link } from "react-router-dom";
import { BASE_URL } from "../Constants";
import HeroSliderComponent from "./HeroSliderComponent";

const HomePageComponent = ({ data, trending, slides }) => {
  const renderTitle = (title = "") =>
    title.split(/\\n|\n/).map((line, index, lines) => (
      <React.Fragment key={`${line}-${index}`}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  const trendingItems = Array.isArray(trending?.contents)
    ? trending.contents
    : [];
  const showTrending = Boolean(trending?.flag) && trendingItems.length > 0;

  return (
    <div className="container py-3 py-md-4 py-xl-5 homepage-shell">
      <HeroSliderComponent slides={slides} />
      {showTrending ? (
        <section className="homepage-trending" aria-labelledby="homepage-trending-title">
          <h2 id="homepage-trending-title" className="homepage-section-title">
            अभी लोकप्रिय
          </h2>
          <div className="homepage-trending-list">
            {trendingItems.map((item) => (
              <Link
                key={item.contentId}
                to={`/content/${item.contentId}`}
                className="homepage-trending-link"
              >
                {item.imagePath ? (
                  <img
                    src={`${BASE_URL}${item.imagePath}`}
                    alt=""
                    className="homepage-trending-image"
                    loading="lazy"
                    decoding="async"
                  />
                ) : null}
                <span className="homepage-trending-title">
                  {item.titlePrimary}
                </span>
              </Link>
            ))}
          </div>
        </section>
      ) : null} 
      <div className="row g-2 g-md-3 row-cols-2 row-cols-lg-3">
        {data.map((item, index) => (
          <div className="col" key={item.subCategoryId}>
            <Link
              to={`/subcategory/${item.subCategoryId}`}
              state={{ resetScroll: true }}
              className="homepage-card h-100"
            >
              <div className="homepage-image-container">
                <img
                  src={
                    item.subCategoryImage
                      ? `${BASE_URL}/static/subcategoryimg/${item.subCategoryImage}`
                      : `${BASE_URL}/static/subcategoryimg/default.png`
                  }
                  alt={item.titlePrimary}
                  className="card-img-top d-block fit-cover homepage-image"
                  width="176"
                  height="176"
                  loading={index < 4 ? "eager" : "lazy"}
                  fetchPriority={index < 2 ? "high" : "auto"}
                  decoding="async"
                />
              </div>
              <div className="card-body text-center homepage-card-body">
                <h4 className="card-title homepage-card-title homepage-title-ellipsis">
                  {renderTitle(item.titlePrimary)}
                </h4>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePageComponent;
